<template>
  <v-dialog max-width="430px" :value="value" @input="$emit('input', $event)">
    <div class="subscribe-modal">
      <v-btn class="close" icon @click="$emit('input', false)">
        <v-icon color="white">$close</v-icon>
      </v-btn>
      <div class="subscribe-modal__title">
        Dont miss the TOUR Championship Golf Ball
      </div>
      <div class="subscribe-modal__description">
        Share your email for info and updates
      </div>
      <v-form @submit.prevent="submit">
        <v-text-field
          placeholder="Email address*"
          dark
          outlined
          v-model="form.email"
        >
          <template #append>
            <v-btn type="submit" icon>
              <v-icon color="white">$arrow_right</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-form>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "SubscribeModal",
  props: {
    value: Boolean,
  },
  data() {
    return {
      form: { email: "" },
    };
  },
  methods: {
    async submit() {
      await this.$recaptchaLoaded();
      this.form.recaptcha = await this.$recaptcha("login");
      await this.$api.EmailSubscription.create(this.form);
      this.$emit("input", false);
      this.form = { email: "" };
    },
  },
};
</script>

<style scoped lang="scss">
.subscribe-modal {
  background: $primary;
  color: white;
  padding: 25px;
  position: relative;

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    text-transform: capitalize;
  }

  &__description {
    margin: 20px 0;
  }

  &::v-deep {
    .v-input__append-inner {
      margin-top: 10px !important;
    }

    .theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
      > .v-input__control
      > .v-input__slot
      fieldset {
      color: rgba(255, 255, 255, 0.66);
    }

    .close {
      right: 0px;
      top: 0px;
    }
  }
}
</style>
